const meterToCanvas = 10;
const adjustDimensions: (
	element: ElementDefinitionType,
	position: ElementPositionType,
	zoom: number
) => [ElementDefinitionType, ElementPositionType] = (element, position, meterToCanvas) => {
	const resPos = { ...position };

	if (resPos.position) {
		resPos.position = [
			resPos.position[0] * meterToCanvas,
			resPos.position[1] * meterToCanvas,
			resPos.position[2] * meterToCanvas
		];
	}
	return [element.cloneWithZoom(meterToCanvas), resPos];
};

export { meterToCanvas, adjustDimensions };
